// extracted by css-extract-rspack-plugin
export default {"wrapper":"aJxFbmrabJ4YiQfo","controls":"QMwVY4HlhQ0E5NGC"};